import * as React from "react";
import { withStyles, IconButton, Snackbar } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import WarningIcon from "@material-ui/icons/Warning";
import green from "@material-ui/core/colors/green";
import amber from "@material-ui/core/colors/amber";

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const styles1 = (theme) => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    //fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    //display: "flex",
    alignItems: "center",
  },
});

function ErrorExceptionDefault(props) {
  const Icon = variantIcon[props.variant];
  return (
    <div>
      <Snackbar
        className={props.classes.error}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={props.open}
        autoHideDuration={3000}
        onClose={props.close}
        message={
          <span id="message-id">
            <Icon /> {props.message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={props.classes.onClose}
            onClick={close}
          >
            <CloseIcon />
          </IconButton>,
        ]}
      />
    </div>
  );
}

export const ErrorException = withStyles(styles1)(ErrorExceptionDefault);



// WEBPACK FOOTER //
// ./src/common/exception/Exception.tsx